module.exports = __webpack_public_path__ + "static/media/img_prn1.d0a8b33e.png";